export default __webpack_public_path__ + "components/weather-icon/static/nightheavyrain@2-37110fefccc6ae72000df18687c0d463.png";